import React from 'react'

import Section from './Section'
import PageLinkItem from './PageLinkItem'
import { links } from '../../../constants/links'

const Levels = () => {
  return (
    <Section title="Levels">
      <PageLinkItem to={links.aLevelsComputing}>
        A' Levels Computing
      </PageLinkItem>
      <PageLinkItem to={links.oLevelsComputing}>
        O' Levels Computing
      </PageLinkItem>
      <PageLinkItem to={links.ibComputing}>IB Computing</PageLinkItem>
      <PageLinkItem to={links.igcseComputing}>IGCSE Computing</PageLinkItem>
      <PageLinkItem to={links.internationalSchools}>
        International Schools
      </PageLinkItem>
    </Section>
  )
}

export default Levels
